import { Component, Input, OnInit, ChangeDetectorRef, ElementRef, ViewChild } from '@angular/core';
import { PreinvoiceModel } from './preinvoice.model';
import { ContactModel } from '../../contact/contact/contact.model';
import { ContactService } from '../../contact/contact/contact.service';
import { InvoiceLineModel } from './invoiceline.model';
import { InvoiceTaxModel } from './invoicetax.model';
import { AccountsAndTaxesModel } from './accountsandtaxes.model';
import { EventEmitter } from '@angular/core';
import { Output, AfterContentChecked } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { BankAccountModel } from '../../finanzas/bancos/bankaccount.model';
import { InvoiceTaxesModel } from './invoicetaxes.model';
import { Observable } from 'rxjs';
import { TaxCalculator } from '../../../shared/taxCalculator';
import { ContactFormV2Component } from '../../../modules_v2/contacts/components/contact-form-v2/contact-form-v2.component';
import { ActualSelected, DatesCF, Utils } from '../../../shared/utils';
import { consts } from '../../../consts';
import moment from 'moment';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { UserCompanyModel } from '../../user/usercompany/usercompany.model';
import { AccountingModel } from '../../user/accountingModel/accountingModel.model';
import { AccountingModelService } from '../../user/accountingModel/accountingModel.service';
import { AccountModel } from '../tickets/account.model';
import { ConceptContactModel } from '../../concept/conceptcontact/conceptcontact.model';
import { ConceptContactService } from '../../concept/conceptcontact/conceptcontact.service';
import { CenterService } from '../../contact/center/center.service';
import { CenterModel } from '../../contact/center/center.model';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { PreinvoiceService } from './preinvoice.service';
import { EfectivoService } from '../../../services/finanzas/efectivo/efectivo.service';
import { Efectivo } from '../../../models/finanzas/efectivo/efectivo.model';
import { PartnersModel } from '../../user/partnersequity/partners/partners.model';
import { PartnersService } from '../../user/partnersequity/partners/partners.service';
import { ConceptModel } from '../../concept/concept/concept.model';
import { ConceptService } from '../../concept/concept/concept.service';
import { PreinvoiceFormItemComponent } from './preinvoice-form-item.component';
import { UserCompanyService } from '../../user/usercompany/usercompany.service';
import { UserFirstTimeActionService } from '../../user/user-first-time-action/user-first-time-action.service';
import { UserFirstTimeNewPreinvoceDialogComponent } from '../../user/user-first-time-action/user-first-time-new-preinvoice/user-first-time-new-preinvoice.component';
import { MasterModel } from '../../../modules_v2/master/models/master.model';
import { MasterService } from '../../../modules_v2/master/services/master.service';
import { ActivityService } from '../../user/activity/activity.service';
import { map } from 'rxjs/operators';
import { Option } from '../../../shared/models/option.model';

@Component({
    selector: 'convfact-preinvoice-form',
    templateUrl: './preinvoice-form.component.html',
    styleUrls: ['./preinvoice.component.css'],
    standalone: false
})

export class PreinvoiceFormComponent implements OnInit, AfterContentChecked {
  @ViewChild('inputField', {static: false}) inputField!: ElementRef;

  isEditMode = false;

  @Input() contactList: ContactModel[] = [];

  @Input() preinvoice: PreinvoiceModel;
  @Input() accountsAndTaxes: AccountsAndTaxesModel;
  @Input() bankAccounts: BankAccountModel;
  @Input() errors: object;

  @Output() onSave = new EventEmitter<any>();

  ready: boolean = false;

  spinner = false;

  entranceList: AccountModel[] = [];

  billMethods = [
    { id: consts.TYPEPAY_CASH, data: consts.TYPEPAY_CASH },
    { id: consts.TYPEPAY_SEPA, data: consts.TYPEPAY_SEPA },
    { id: consts.TYPEPAY_BANKTRANSFERENCE, data: consts.TYPEPAY_BANKTRANSFERENCE },
    { id: consts.TYPEPAY_CONFIRMING, data: consts.TYPEPAY_CONFIRMING },
    { id: consts.TYPEPAY_PAGARES, data: consts.TYPEPAY_PAGARES },
    { id: consts.TYPE_TARJETA, data: consts.TYPE_TARJETA },
    { id: consts.TYPE_SOCIO, data: consts.TYPE_SOCIO },
  ];

  payMethodCtrl: UntypedFormControl;
  filteredPayMethod: Observable<any>;

  accountAndTaxesList = new AccountsAndTaxesModel;
  aux: number;
  result: number;
  taxes: Array<InvoiceTaxModel>;
  taxesView: string[] = [];

  taxesInvoice: InvoiceTaxesModel[] = [];
  taxesToTheView: string[] = [];

  contactSelected: ContactModel = new ContactModel();
  rates: ConceptContactModel[] = [];
  centers: CenterModel[] = [];

  public get centerOptions(): Option[] {
    return [
      { label: 'Seleccionar', value: '00000000-0000-0000-0000-000000000000' },
      ...this.centers.map(c => ({ label: c.code + ' - ' + c.name, value: c.uid }))
    ];
  }

  contactPreinvoiceOK = false;

  userCompany: UserCompanyModel;
  accountingModel: AccountingModel[];

  newContactLoaded = new BehaviorSubject<boolean>(true);

  public showNumberKilometer: boolean = false;

  public efectivoList: Efectivo[] = [];
  public sociosList: PartnersModel[] = [];

  concepts = Array<ConceptModel>();
  conceptCtrl: UntypedFormControl;
  filteredConcepts: Observable<ConceptModel[]>;

  public saved: boolean = false;

  projects: MasterModel[] = [];
  isProjectEnable: boolean = false;

  constructor(
    public snackBar: MatSnackBar,
    private contactService: ContactService,
    private taxCalculator: TaxCalculator,
    private conceptService: ConceptService,
    private dialog: MatDialog,
    private accountingModelService: AccountingModelService,
    private conceptContactService: ConceptContactService,
    private centerService: CenterService,
    private cdr: ChangeDetectorRef,
    public preinvoiceService: PreinvoiceService,
    private efectivoService: EfectivoService,
    private partnersService: PartnersService,
    private userCompanyService: UserCompanyService,
    private userFirstTimeActionService: UserFirstTimeActionService,
    private masterService: MasterService,
    private activityService: ActivityService
  ) {
  }


  displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container']; this.snackBar.open(message, 'Cerrar', options);
  }

  restoreRates() {
    // if (this.rates.length > 0 && this.preinvoice.invoiceLines.length > 0) {
    //     this.preinvoice.invoiceLines.forEach(element => {
    //         var rate = this.rates.find(f => f.conceptUid == element.conceptUid);
    //         if (rate != null && rate.price != null) {
    //             element.unityAmount = element.netPrice;
    //         }
    //         element.conceptCode = null;
    //     });
    // }

    this.rates = [];
    this.centers = [];
  }

  checkRates() {
    // if (this.preinvoice.receiverUid != null && this.rates.length > 0 && this.preinvoice.invoiceLines.length > 0) {
    //     this.preinvoice.invoiceLines.forEach(element => {
    //         var rate = this.rates.find(f => f.conceptUid == element.conceptUid);
    //         if (rate != null && rate.price != null) {
    //             element.unityAmount = rate.price;
    //             element.conceptCode = rate.conceptCode;
    //         }
    //     });
    // }
  }

  onSelectContact(companyName) {
    const contact = this.contactList.filter(c => c.companyName == companyName)[0];
    this.preinvoice.receiverUid = contact.uid;

    this.contactService.loadData(this.preinvoice.receiverUid).then(response => {
      this.contactSelected = response;

      this.preinvoice.entranceAccount = response.entranceAccount;
      this.preinvoice.expenseAccount = response.expenseAccount;

      let account = null;
      if (Utils.IsNullOrEmpty(this.preinvoice.entranceAccount)) {
        if (this.userCompany.isSalesInvoice) {
          account = this.entranceList.filter(c => c.number == '7000000001')[0];
        }

        if (this.userCompany.isServiceInvoice) {
          account = this.entranceList.filter(c => c.number == '7050000001')[0];
        }

        if (this.userCompany.isSalesInvoice && this.userCompany.isServiceInvoice) {
          account = this.entranceList.filter(c => c.number == '7000000001')[0];
        }
      } else {
        account = this.entranceList.filter(c => c.number == response.entranceAccount)[0];

      }

      if (account) {
        this.preinvoice.entranceAccount = account.number + ' - ' + account.name;
      }


      this.preinvoice.typePay = response.paymentTypeClient;


      const line = new InvoiceLineModel();
      line.discount = 0;
      line.position = 0;
      line.product = "";
      line.quantity = 0;
      line.totalLine = 0;
      line.unityAmount = 0;
      line.position = this.preinvoice.invoiceLines.length;

      if (this.contactSelected.paymentClientUid != null) {
        this.preinvoice.typePayBankAccount = response.paymentClientUid;
      }
      if (this.contactSelected.clientEfectivoId != null) {
        this.preinvoice.efectivoId = response.clientEfectivoId;
      }
      if (this.contactSelected.clientPartnersId != null) {
        this.preinvoice.partnersId = response.clientPartnersId;
      }


      if (this.contactSelected.expirationClient == null) {
        const expiration = new Date();
        this.preinvoice.invoiceExpiration = expiration;
      }
      else {
        if (this.contactSelected != null && this.contactSelected.expirationClient != null && DatesCF.toDate(this.preinvoice.invoiceRelease.toLocaleDateString()).valid) {
          this.preinvoice.invoiceExpiration = new Date(moment(this.preinvoice.invoiceRelease).add(this.contactSelected.expirationClient, 'days').toDate());
        }
      }

    });
    this.assignContactUid(contact.uid)
  }

  assignContactUid(contactUid) {
    this.contactPreinvoiceOK = true;

    this.restoreRates();

    this.conceptContactService.getListByContact(contactUid).then(data => {
      this.rates = data;
      this.checkRates();
    });

    this.centerService.getListByContact(contactUid).then(data => {
      this.centers = data;
      this.cdr.detectChanges();
    });

    this.ready = true;

  }

  setExpiration(event: MatDatepickerInputEvent<Date>) {
    let auxDate = new Date();
    auxDate = event.value;

    if (auxDate != null && this.contactSelected != null &&
      this.contactSelected.expirationClient != null &&
      DatesCF.toDate(auxDate.toLocaleDateString()).valid) {
      this.preinvoice.invoiceRelease = auxDate;
      this.preinvoice.invoiceExpiration = new Date(moment(auxDate).add(this.contactSelected.expirationClient, 'days').toDate());
    }
  }

  newContact(isExpense: boolean) {
    const contactScratch = new ContactModel();

    if (isExpense === false) {
      contactScratch.isProvider = false;
      contactScratch.isClient = true;
    }

    contactScratch.isPhysical = true;

    const dialogNewContact = ContactFormV2Component.open(this.dialog, { scratch: contactScratch });

    this.newContactLoaded.next(false);

    dialogNewContact
      .pipe(
        map(value => {
          if (value === undefined) {
            this.newContactLoaded.next(true);
          }
          return value;
        })
      )
      .subscribe(result => {
        if (result !== undefined) {
          this.contactService.getListClients().then(response => {
            if (response.length == this.contactList.length) {
              this.contactList = response;
              this.newContactLoaded.next(null);
            } else {
              this.contactList = response;
              this.newContactLoaded.next(true);
            }
          }).catch(() => {
            this.newContactLoaded.next(true);
            this.displayInfo('Ha ocurrido un error inesperado al obtener el listado de contactos');
          });
        }
      });
  }

  displayFn(user?: ContactModel): string | undefined {
    return user ? user.companyName : undefined;
  }

  filterPayMethod(val) {
    const self = this;
    for (const method of this.billMethods) {
      if (method === val) {
        self.preinvoice.typePay = method.id;
      }
    }

    return val ? this.billMethods.filter(s => s.id.toLowerCase().indexOf(val.toLowerCase()) === 0)
      : this.billMethods;
  }

  toggleUseDeliverAddress(event: MatCheckboxChange) {
    if (!this.contactSelected || !this.contactSelected.deliverAddress || this.contactSelected.deliverAddress.trim() === '') {
      this.displayInfo(
        "El contacto seleccionado no dispone de domicilio de entrega, puede cumplimentarlo en la ficha Cliente en Contactos."
      );

      this.preinvoice.useDeliverAddress = false;
      event.source.checked = false;
      return;
    }

    this.preinvoice.useDeliverAddress = event.checked;
  }

  getData() {
    if (ActualSelected.iaeIdHeading === consts.IAE_ID_VEHICLES) {
      this.showNumberKilometer = true;
    }


    this.efectivoService.list().then(listadoEfectivos => {
      this.efectivoList = listadoEfectivos;
      this.cdr.detectChanges();
      this.contactService.getListClients().then(response => {
        this.contactList = response;
        this.userCompanyService.loadData().then(response => {
          this.userCompany = response;

          if (Utils.IsNullOrEmpty(this.preinvoice.entranceAccount)) {
            let account = null;
            if (this.userCompany.isSalesInvoice) {
              account = this.entranceList.filter(c => c.number == '7000000001')[0];
            }

            if (this.userCompany.isServiceInvoice) {
              account = this.entranceList.filter(c => c.number == '7050000001')[0];
            }

            if (this.userCompany.isSalesInvoice && this.userCompany.isServiceInvoice) {
              account = this.entranceList.filter(c => c.number == '7000000001')[0];
            }

            if (account)
              this.preinvoice.entranceAccount = account.number + ' - ' + account.name;
          }

          this.payMethodCtrl = new UntypedFormControl();
          this.filteredPayMethod = this.payMethodCtrl.valueChanges
            .pipe(map(method => this.filterPayMethod(method)));

          this.accountingModelService.getList('ingreso').then(data => {

            let incomesAccount: AccountModel[] = [];
            data.forEach(account => {
              if (Utils.AccountIsForIncomes(account.type)) {
                const temp: AccountModel = new AccountModel();
                temp.name = account.name;
                temp.number = account.number;
                temp.type = account.type;
                temp.id = account.number + ' - ' + account.name;
                incomesAccount.push(temp);
              }
            });
            this.entranceList = incomesAccount;
            incomesAccount = [];

            if (Utils.IsNullOrEmpty(this.preinvoice.entranceAccount)) {
              let account = null;
              if (this.userCompany.isSalesInvoice) {
                account = this.entranceList.filter(c => c.number == '7000000001')[0];
              }

              if (this.userCompany.isServiceInvoice) {
                account = this.entranceList.filter(c => c.number == '7050000001')[0];
              }

              if (this.userCompany.isSalesInvoice && this.userCompany.isServiceInvoice) {
                account = this.entranceList.filter(c => c.number == '7000000001')[0];
              }
              if (account) {
                this.preinvoice.entranceAccount = account.number + ' - ' + account.name;
              }
            }
          });

          if (this.preinvoice.receiverUid != null) {
            this.assignContactUid(this.preinvoice.receiverUid);
          } else {
            this.ready = true;
          }
        });
      }).catch(err => {
        this.newContactLoaded.next(true);
        this.displayInfo('Ha ocurrido un error inesperado al obtener el listado de contactos');
      });
    });


    this.partnersService.list()
      .then(response => {
        this.sociosList = response
      });

    //Projects

    this.masterService.getProjects().subscribe(data => {
      this.projects = data;
      this.cdr.detectChanges();
    });
  }

  ngOnInit() {
    this.getData();

    this.activityService.loadData(ActualSelected.activitySelected).then(activity => {
      this.isProjectEnable = activity.isProject;
    });


    this.conceptService.getList().then(
      concepts => {
        this.concepts = concepts;
      }
    )

    this.userFirstTimeActionService.getAll().then(response => {
      if (response && response.filter(c => c.action == 'CREATE_PREINVOICE').length == 0) {
        const dialogRef = this.dialog.open(UserFirstTimeNewPreinvoceDialogComponent, {
          panelClass: 'custom-dialog'
        });

        dialogRef.afterClosed().subscribe((result: boolean) => {
          if (result) {
            this.userFirstTimeActionService.add('CREATE_PREINVOICE').then(res => {

            });
          }
        });
      }
    });
  }

  ngAfterContentChecked() {}

  calcularSubtotal() {
    return this.taxCalculator.calcularSubtotal(this.preinvoice);
  }

  calcularTotal() {
    this.preinvoice.total = this.taxCalculator.calcularTotal(this.preinvoice);
    return this.preinvoice.total;
  }


  impuestos(): string[] {
    return this.taxCalculator.impuestos(this.preinvoice, this.result, this.aux, [], [], []);
  }

  // addInvoiceLine() {
  //     var line = new InvoiceLineModel();
  //     line.position = this.preinvoice.invoiceLines.length;
  //     this.preinvoice.invoiceLines.push(line);
  // }

  addInvoiceLine() {
    let line = new InvoiceLineModel();

    if (this.contactSelected && this.contactSelected.taxClientUid != null) {
      const tax: InvoiceTaxModel = this.accountsAndTaxes['taxes'].find(x => x.uid === this.contactSelected.taxClientUid);
      line.taxes.push(tax);
    }
    if (this.contactSelected && this.contactSelected.taxClientSecondUid != null) {
      const tax: InvoiceTaxModel = this.accountsAndTaxes['taxes'].find(x => x.uid === this.contactSelected.taxClientSecondUid);
      line.taxes.push(tax);
    }

    const dialog = this.dialog.open(PreinvoiceFormItemComponent, {
      data: { taxes: this.accountsAndTaxes.taxes, item: line },
    }).afterClosed().subscribe(result => {
      if (result && result.action === 'save') {
        line = result.item;
        line.position = this.preinvoice.invoiceLines.length;
        this.preinvoice.invoiceLines.push(line);
      }
      this.cdr.detectChanges();
    });
  }

  removeInvoiceLine(invoiceLine) {
    this.preinvoice.invoiceLines.splice(this.preinvoice.invoiceLines.indexOf(invoiceLine), 1);
  }

  save(preinvoice) {
    let noError = true;

    if (!Utils.DateIsInFiscalYear(preinvoice.invoiceRelease)) {
      noError = false;
      this.displayInfo("La fecha de creación y el año fiscal seleccionado, no son el mismo.");
    }

    if (preinvoice.entranceAccount == null || preinvoice.entranceAccount == "") {
      noError = false;
      this.displayInfo("Debe especificar la cuenta contable de ingreso.");
    }

    if (preinvoice.typePay == null || preinvoice.typePay == "") {
      noError = false;
      this.displayInfo("Debe especificar la forma de cobro.");
    }

    if ((preinvoice.typePay == consts.TYPEPAY_BANKTRANSFERENCE ||
      preinvoice.typePay == consts.TYPEPAY_SEPA ||
      preinvoice.typePay == consts.TYPE_TARJETA ||
      preinvoice.typePay == consts.TYPEPAY_CONFIRMING ||
      preinvoice.typePay == consts.TYPEPAY_PAGARES)
      && (preinvoice.typePayBankAccount == null || preinvoice.typePayBankAccount == "")) {
      noError = false;
      this.displayInfo("Debe especificar la cuenta bancaria.");
    }

    if (preinvoice.numberKilometers == null || preinvoice.numberKilometers === '') {
      preinvoice.numberKilometers = null;
    }
    if (preinvoice.numberKilometers > 9999999.99) {
      noError = false;
      this.displayInfo("El campo 'Número de kilometros' no puede ser superior 9 999 999.99");
    }

    if (preinvoice.typePay !== "Efectivo") {
      preinvoice.efectivoId = null;
    }

    // Controlamos que todas las lineas de base tengan impuestos
    const invoiceLinesHaveTaxes: string = this.invoiceLinesHaveTaxes(preinvoice);

    if (!Utils.IsNullOrEmpty(invoiceLinesHaveTaxes)) {
      this.displayInfo(invoiceLinesHaveTaxes);
      return;
    }

    if (noError) {
      preinvoice.projectUid = this.preinvoice.projectUid;
      this.preinvoiceService.saveRequestUpdateValue(true);
      this.preventNullOrEmptyValues(preinvoice);
      this.onSave.emit(preinvoice);
    }

  }

  private invoiceLinesHaveTaxes(preinvoice: any): string {

    if (preinvoice.invoiceLines) {

      for (let i = 0; i < preinvoice.invoiceLines.length; i++) {

        if (preinvoice.invoiceLines[i].taxes && preinvoice.invoiceLines[i].taxes.length === 0) {
          return 'Compruebe que todos sus conceptos incluyan al menos un impuesto';
        }

        if (preinvoice.invoiceLines[i].taxes && !preinvoice.invoiceLines[i].taxes.find(x => (x.type === 'IVA' || x.type === 'IGIC'))) {
          return 'Incluya al menos un impuesto indirecto (IVA o IGIC) en cada concepto';
        }

      }

    }

    return '';
  }

  preventNullOrEmptyValues(preinvoice) {
    for (let i = 0; i < preinvoice.invoiceLines.length; i++) {

      if (preinvoice.invoiceLines[i].discount == null || preinvoice.invoiceLines[i].discount === '') {
        preinvoice.invoiceLines[i].discount = 0;
      }
      if (preinvoice.invoiceLines[i].quantity == null || preinvoice.invoiceLines[i].quantity === '') {
        preinvoice.invoiceLines[i].quantity = 0;
      }
      if (preinvoice.invoiceLines[i].unityAmount == null || preinvoice.invoiceLines[i].unityAmount === '') {
        preinvoice.invoiceLines[i].unityAmount = 0;
      }

    }
  }

  changeToggle(element, other) {
    this.preinvoice[other] = (this.preinvoice[element]);
  }

  toggleEditMode(index) {
    const dialog = this.dialog.open(PreinvoiceFormItemComponent, {
      data: { taxes: this.accountsAndTaxes.taxes, item: this.preinvoice.invoiceLines[index] },
    }).afterClosed().subscribe(result => {
      if (result && result.action === 'save') {
        this.preinvoice.invoiceLines[index] = result.item;
      } else {

      }
      this.cdr.detectChanges();
    });

  }

  calcularTotalesLinea(invoiceLine) {
    invoiceLine.totalLine = this.taxCalculator.calcularTotalLinea(invoiceLine);
    return invoiceLine.totalLine;
  }

  saveLine(index, item) {
    this.preinvoice.invoiceLines[index] = item;
  }

  getStrTaxes(taxes: any[]) {
    if (taxes != null) {

      if (taxes.length > 0 && taxes[0] != null) {

        return taxes.map(tax => tax.name).join(', ');

      }

    }


  }
  public trackByIndex(i: number) { return i; }

}
